import React from 'react';
import { useLocation } from 'react-router-dom';
import headerStyles from './header.module.scss';
import skeletonStyles from './headerSkeleton.module.scss';
import { CasinoIcon, RewardsIcon, LogoIcon } from 'components/icons';

const HeaderSkeleton: React.FC = () => {
  const location = useLocation();
  const activeTab = location.pathname === '/sports' ? 'sports' : 'casino';

  return (
    <div className={headerStyles.header_wrapper}>
      <header className={headerStyles.header}>
        <div className={headerStyles.header_left}>
          <div className={headerStyles.logo}>
            <span className={headerStyles.logo_w}>
              <LogoIcon width={120} height={38} fill="#ffffff" />
            </span>
          </div>
          <div className={headerStyles.category_toggle}>
            <button
              className={`${headerStyles.toggle_btn} ${activeTab === 'casino' ? headerStyles.active : ''}`}
              style={{ cursor: 'default' }}
            >
              <CasinoIcon />
              Casino
            </button>
            {/* <button
            className={`${headerStyles.toggle_btn} ${activeTab === 'sports' ? headerStyles.active : ''}`}
            style={{ cursor: 'default' }}
          >
            <SportsIcon />
            Sports
          </button> */}
            <button className={headerStyles.toggle_btn} style={{ cursor: 'default' }}>
              <RewardsIcon />
              Rewards
            </button>
          </div>
        </div>
        <div className={headerStyles.header_right}>
          <div className={skeletonStyles.walletPlaceholder} />
          <div className={skeletonStyles.buttonPlaceholder} />
          <div className={skeletonStyles.profilePlaceholder} />
        </div>
      </header>
    </div>
  );
};

export default HeaderSkeleton;
